import { Fragment } from 'react';

import HideIcon from '@usas/ui-web/components/icons/HideIcon';
import ShowIcon from '@usas/ui-web/components/icons/ShowIcon';
import DeleteIcon from '@usas/ui-web/components/icons/DeleteIcon';

import { FormatMoneyWithSymbol } from '@usas/ui-web/utils/FormatMoney';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const SmallDetailTableRow = ({ purchaseItemDetail, onDeletePurchaseItemDetailClicked }) => {
  return (
    <Fragment>
      <div className={global.SmallDetailTableRow}>
        <div className={global.SmallTableDetailRowHead}>
          <span className='hidden-xs'>{purchaseItemDetail.itemDescription || <span>&nbsp;</span>}</span>&nbsp;
          {purchaseItemDetail.canBeDeleted === true && <button className={global.IconButton}
            type="button"
            onClick={(e) => onDeletePurchaseItemDetailClicked(e, purchaseItemDetail)}>
            <DeleteIcon />
          </button>}
        </div>
        <div className={global.SmallTableRowInfo}>
          <div className='row'>
            <div className={[global.SmallTableRowLabels, 'col-xs-6 visible-xs'].join(' ')}>Item Description</div>
            <div className={[global.SmallTableRowData, 'col-xs-6 visible-xs'].join(' ')}>{purchaseItemDetail.itemDescription || <span>&nbsp;</span>}</div>
            <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Item Price</div>
            <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{purchaseItemDetail.itemPrice >= 0 ? FormatMoneyWithSymbol(purchaseItemDetail.itemPrice) : <span>&nbsp;</span>}</div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

const SmallDetailTable = ({ purchaseItem, onDeletePurchaseItemDetailClicked }) => {
  return (
    <div className={global.SmallDetailTable}>
      {Array.isArray(purchaseItem.purchaseItemDetails) && purchaseItem.purchaseItemDetails.length > 0 &&
        purchaseItem.purchaseItemDetails.map((purchaseItemDetail, i) =>
          <SmallDetailTableRow
            purchaseItemDetail={purchaseItemDetail}
            onDeletePurchaseItemDetailClicked={onDeletePurchaseItemDetailClicked}
            key={i}
          />)}
    </div>
  );
};

const OrgUnitAdminPurchasesSmallGrid = ({ gridData, isLoading, onClick, expandedId, onDeletePurchaseItemDetailClicked }) => (
  <div className={[global.SmallTable, 'hidden-md hidden-lg'].join(' ')}>
    {isLoading === true
      ? (
        <div className={global.SmallTableRow}>
          <div className={global.SmallTableRowHead}>
            &nbsp;
          </div>
          <div className={global.SmallTableRowInfo}>
            <div className={global.SmallTableRowLabels}>
              Loading...
            </div>
          </div>
        </div>
      ) : gridData?.length > 0
        ? gridData?.map((purchaseItem, i) => (
          <Fragment key={`${purchaseItem.omeMeetPriceId}+${purchaseItem.omeFeeTypeId}+${purchaseItem.isAdjustmentTransaction}+${purchaseItem.afterCapFee}`}>
            <div className={global.SmallTableRow} key={`${purchaseItem.omeMeetPriceId}+${purchaseItem.omeFeeTypeId}+${purchaseItem.isAdjustmentTransaction}+${purchaseItem.afterCapFee}`}>
              <div className={global.SmallTableRowHead}><span className='hidden-xs'>{purchaseItem.omeFeeTypeName || <span>&nbsp;</span>}</span>&nbsp;
                {Array.isArray(purchaseItem.purchaseItemDetails) && purchaseItem.purchaseItemDetails.length > 0 &&
                  <button className={global.IconButton}
                    type="button"
                    onClick={(e) => onClick(e, `${purchaseItem.omeMeetPriceId}+${purchaseItem.omeFeeTypeId}+${purchaseItem.isAdjustmentTransaction}+${purchaseItem.afterCapFee}`)}>
                    {expandedId === `${purchaseItem.omeMeetPriceId}+${purchaseItem.omeFeeTypeId}+${purchaseItem.isAdjustmentTransaction}+${purchaseItem.afterCapFee}` ? <HideIcon /> : <ShowIcon />}
                  </button>}
              </div>
              <div className={global.SmallTableRowInfo}>
                <div className='row'>
                  <div className={[global.SmallTableRowLabels, 'col-xs-6 visible-xs'].join(' ')}>Line Item</div>
                  <div className={[global.SmallTableRowData, 'col-xs-6 visible-xs'].join(' ')}>{purchaseItem.omeFeeTypeName || <span>&nbsp;</span>}</div>
                  <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Line Item Cost</div>
                  <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{purchaseItem.amount !== null && purchaseItem.amount > 0 ? '$' + purchaseItem.amount.toFixed(2) : <span>$0.00</span>}</div>
                  <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Quantity</div>
                  <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{purchaseItem.quantity !== null && purchaseItem.quantity >= 0 ? purchaseItem.quantity : <span>0</span>}</div>
                  <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Total Cost</div>
                  <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{purchaseItem.totalAmount !== null && purchaseItem.totalAmount > 0 ? '$' + purchaseItem.totalAmount.toFixed(2) : <span>$0.00</span>}</div>
                </div>
              </div>
            </div>
            {expandedId === `${purchaseItem.omeMeetPriceId}+${purchaseItem.omeFeeTypeId}+${purchaseItem.isAdjustmentTransaction}+${purchaseItem.afterCapFee}` &&
              <SmallDetailTable
                key={i}
                purchaseItem={purchaseItem}
                onDeletePurchaseItemDetailClicked={onDeletePurchaseItemDetailClicked}
              />}
          </Fragment>
        )) : (
          <div className={global.SmallTableRow}>
            <div className={global.SmallTableRowHead}>
              &nbsp;
            </div>
            <div className={global.SmallTableRowInfo}>
              <div className={global.SmallTableRowLabels}>No Purchases</div>
            </div>
          </div>
        )
    }
  </div >
);

export default OrgUnitAdminPurchasesSmallGrid;